import { render, staticRenderFns } from "./BoxTagging.vue?vue&type=template&id=dc368a26&scoped=true"
import script from "./BoxTagging.vue?vue&type=script&lang=js"
export * from "./BoxTagging.vue?vue&type=script&lang=js"
import style0 from "./BoxTagging.vue?vue&type=style&index=0&id=dc368a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc368a26",
  null
  
)

export default component.exports